import React from 'react'

import Plagiarism from '../helpers/plagiarism-helper'

import styles from './chart-description.module.scss'

interface PlagiarismCopy {
  normal: React.ReactNode
  significant: React.ReactNode
  none: React.ReactNode
}

const normalPlagiarism: PlagiarismCopy = {
  normal: 'and have also detected plagiarism',
  significant: 'and have also detected significant plagiarism',
  none: '',
}

const emphasizePlagiarism: PlagiarismCopy = {
  normal: (
    <>
      <span className={styles.chartDescriptionBoldText}>We have found plagiarism</span> in your text and have also
      detected
    </>
  ),
  significant: (
    <>
      <span className={styles.chartDescriptionBoldText}>We have found significant plagiarism</span> in your text and
      have also detected
    </>
  ),
  none: 'We didn’t find any plagiarism, but we found',
}

function selectPlagiarismText(plagiarism: Plagiarism, texts: PlagiarismCopy) {
  if (plagiarism.isSignificant) {
    return texts.significant
  }
  if (plagiarism.isNormal) {
    return texts.normal
  }
  return texts.none
}

export const getPlagiarismTextEnding = (plagiarism: Plagiarism) => selectPlagiarismText(plagiarism, normalPlagiarism)
export const getPlagiarismTextBeginning = (plagiarism: Plagiarism) =>
  selectPlagiarismText(plagiarism, emphasizePlagiarism)
